<template>
  <div>
    <router-view/>
    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item>
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? home.active : home.inactive"/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>订单</span>
        <template #icon="lists">
          <img :src="lists.active ? list.active : list.inactive"/>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>

import {getToken} from "@/utils/auth";


export default {
  name: "home",
  data() {
    return {
      active: 0,
      home: {
        active: '/images/foot_icon_home_a@3x.png',
        inactive: '/images/foot_icon_home@3x.png',
      },
      list: {
        active: '/images/foot_icon_dingdan_a@3x.png',
        inactive: '/images/foot_icon_dingdan@3x.png',
      },
    };
  },
  created() {
    if (getToken() === null) {
      this.$router.push({path: '/login'})
    } else {
      switch (this.$route.name) {
        case 'home':
          this.active = 0
          break
        case 'order':
          this.active = 1
          break
      }
    }
  },
  methods: {
    onChange(index) {
      switch (index) {
        case 0:
          this.$router.push({path: '/'})
          break
        case 1:
          this.$router.push({path: '/order'})
          break
      }
    }
  }
}
</script>

<style>


</style>
